import {
  resourceReducer,
} from 'redux-resource';
import {
  selection,
  includedResources,
} from 'redux-resource-plugins';

import {
  allListPlugin,
  multiListPlugin,
  customListPlugin,
} from './plugins';

export default resourceReducer('folders', {
  initialState: {
    ...selection.initialState,
  },
  plugins: [
    selection,
    allListPlugin,
    multiListPlugin,
    customListPlugin,
    includedResources,
  ],
});
